<template>
    <div style="position: relative;" ref="poll_post_wrap">
        <div style="">
            <div style="display: flex; gap: 8px; position: relative;">
                <div>
                    <div style="width: 40px; display: flex; justify-content: center; align-items: center; height: 40px; border: 2px solid #d9d9d9; border-radius: 50%; background-color: #f5f5f5;">
                        <img style="width: 20px;" :src="require('@/assets/img/poll_img.png')" alt="">
                    </div>
                </div>
                <div @click="showDetail" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                    <div style="font-weight: 500; font-size: 12px; color: var(--color-main); line-height: 20px;">투표하기</div>
                    <div style="font-size: 15px; font-weight: 500; line-height: 18px; margin-bottom: 4px;">{{ copyPollPost.contents }}</div>
                    <div style="display: flex; align-items: center; gap: 4px; font-weight: 400; font-size: 12px; line-height: 16px; color:#606060;">
                        {{ copyPollPost.poll_cnt }}명 응답
                        <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                        {{ copyPollPost.insert_date | agoDateStr }}
                    </div>
                    <div>
                        <div v-if="copyPollPost.poll_type === POLL_TYPE.TEXT">
                            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px;">
                                <InteractionOfBtnBackgroundColor style="width: 270px; border-radius: 50px;" :curType="null" :isStopInteraction="copyPollPost.is_me_poll ? true : false" originColor="#fff" completeColor="#fff" changeColor="#f5f5f5" v-for="option, i in copyPollPost.options" :key="i + 'option'">
                                    <div class="poll_btn" @click.stop="submitPoll(POLL_TYPE.TEXT, option)">
                                        <div ref="progress_bar" class="progress_bar"></div>
                                        <div :class="copyPollPost.is_me_poll ? 'complete' : 'not_complete'" style="position: absolute; transition: all 0.3s; display: flex; gap: 4px; align-items: center;">
                                            <div style="line-height: 18px;">{{ option.contents }}</div>
                                            <img v-if="copyPollPost.is_me_poll && copyPollPost.is_me_poll.poll_option_idx === option.idx" style="width: 8px;" :src="require('@/assets/img/poll_check.png')" alt="">
                                        </div>
                                        <div v-if="copyPollPost.is_me_poll" style="float: right; position: relative;">{{ option.ratio }}%</div>
                                    </div>
                                </InteractionOfBtnBackgroundColor>
                            </div>
                            <div @click.stop="deletePoll(POLL_TYPE.TEXT)" v-if="copyPollPost.is_me_poll" style="margin-top: 8px; font-size: 12px; font-weight: 500; line-height: 16px; color: #808080;">투표 취소</div>
                        </div>
                    </div>
                </div>
                <div @click="confirmHidePoll" style="width: 31px; position: absolute; right: 0; text-align: center;">
                    <img style="width: 7px;" :src="require('@/assets/img/poll_hide_btn.png')" alt="">
                </div>
                <!-- <div style="flex:1;"></div> -->
            </div>
            <div style="" v-if="copyPollPost.poll_type === POLL_TYPE.IMAGE">
                <div class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 12px; overflow-y: hidden;">
                    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-top: 12px; padding-left: 45px;">
                        <div style="display: flex; flex-direction: column;" v-for="option, i in copyPollPost.options" :key="i + 'optionImage'">
                            <InteractionOfScale :isStopInteraction="copyPollPost.is_me_poll ? true : false">
                                <div ref="test" @click.stop="submitPoll(POLL_TYPE.IMAGE, option)" :style="{ border: copyPollPost.is_me_poll && copyPollPost.is_me_poll.poll_option_idx === option.idx ? '1px solid #bbbbbb' : '1px solid #ebebeb' }" style="border-radius: 12px; max-width: 153px; max-height: 153px; transition: all 0.3s; overflow: hidden;">
                                    <img style="width: 100%; height: 100%; object-fit: cover; vertical-align: top; border-radius: 12px;" :src="$resourcePath + option.image_path" alt="">
                                    <!-- <img style="width: 100%; max-height: 153px; object-fit: cover; border-radius: 12px;" :src="require('@/assets/img/test_img.png')" alt=""> -->
                                </div>
                            </InteractionOfScale>
                            <div style="display: flex; align-items: center; margin-top: 8px; ">
                                <div style="line-height: 16px; font-size: 12px; font-weight: 500; word-break: break-all; flex: 1;">{{ option.contents }}</div>
                                <div style="font-size: 12px; font-weight: 500;" v-if="copyPollPost.is_me_poll">{{ option.ratio }}%</div>
                            </div>
                            <Transition name="fade">
                                <div v-if="copyPollPost.is_me_poll" style="margin-top: 12px;">
                                    <div style="height: 12px; overflow: hidden; border-radius: 50px; width: 100%; background-color: #ebebeb; position: relative;">
                                        <div ref="progress_bar" class="progress_bar"></div>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                    </div>
                </div>
                <div @click.stop="deletePoll(POLL_TYPE.IMAGE)" v-if="copyPollPost.is_me_poll" style="margin-top: 8px; font-size: 12px; font-weight: 500; line-height: 16px; color: #808080; padding-left: 45px;">투표 취소</div>
            </div>
            <div v-if="!isDetail" style="display: flex; gap: 16px; align-items: center; flex: 1; margin-top: 12px; margin-left: 46px;">
                <div @click.stop="() => { }" @touchstart.stop="touchStart($event)" @touchend.stop="touchEnd($event)" style="display: flex; gap: 5px; align-items: center; ">
                    <div style="position: relative;">
                        <img :style="{ opacity: curLikeYn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                        <img style="width: 16px; position: relative; z-index: 2;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                        <!-- <img v-else style="width: 16px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt=""> -->
                    </div>
                    <div style="font-weight: 700; font-size: 12px;">{{ curLikeNumber }}</div>
                </div>
                <div @click.stop="showDetail" style="display: flex; gap: 5px; align-items: center;">
                    <img style="width: 16px;" :src="require('@/assets/img/feed_reply.png')" alt="">
                    <div style="font-weight: 700; font-size: 12px;">{{ copyPollPost.reply_number === null ? 0 : copyPollPost.reply_number }}</div>
                </div>
            </div>
            <div @click="showDetail" v-if="copyPollPost.reply && !isDetail" style="margin-left: 22px; background-color: #f5f5f5; margin-top: 10px; border-radius: 10px; padding: 10px;">
                <div style="font-size: 12px; font-weight: 700; line-height: 20px;">댓글 <span style="color: #b6b6b6;">{{ copyPollPost.reply_number === null ? 0 : copyPollPost.reply_number }}</span></div>
                <div style="display: flex; gap: 8px; margin-top: 6px; align-items: center;">
                    <div style="width: 40px; height: 40px;" @click="$Util.showProfile(copyPollPost.reply[0].writer_idx, copyPollPost.reply[0].writer_type)">
                        <ProfileImage style="width: 40px; height: 40px;" :imagePath="copyPollPost.reply[0].image_path"></ProfileImage>
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px; display:flex; align-items: center;" @click="$Util.showProfile(each.writer_idx, each.writer_type)">
                            {{ copyPollPost.reply[0].nic_name }}
                            <span style="font-weight: 900; font-size: 11px; margin-left: 4px; color: var(--color-main);">{{ copyPollPost.reply[0].position }}</span>
                            <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%; margin: 0 4px;"></div>
                            <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060;">{{ copyPollPost.reply[0].insert_date | agoDateStr }}</div>
                        </div>
                        <div class="ellipsis" style="font-weight: 500; font-size: 15px; line-height: 24px; word-break: break-all; white-space: pre-line;">{{ copyPollPost.reply[0].contents }}</div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="bookmarkFlag">
            <BookmarkPopup :zIndex="11" :background="'#fff'" :height="306" :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
                <div>
                    <div @click="closeBookmarkPopup(false)" style="font-weight: 700;">닫기</div>
                    <div style="text-align: center; margin-top: 32px;">
                        <div style="font-weight: 700; font-size: 20px; line-height: 24px;">이 투표를 숨기시겠어요?</div>
                        <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">이 투표는 더 이상 피드에 나타나지 않습니다.<br>새로운 투표가 생기면 다시 알려드릴게요.</div>
                        <div @click="hidePoll" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
                    </div>
                </div>
            </BookmarkPopup>
        </template>
    </div>
</template>

<script>
import { POLL_TYPE } from '@/Constants'
import InteractionOfScale from '@/components/common/InteractionOfScale'
import ProfileImage from '@/components/common/ProfileImage'
import InteractionOfBtnBackgroundColor from '@/components/common/InteractionOfBtnBackgroundColor'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup'
import ResponseCode from "../../ResponseCode";

const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export default {
    name: 'CommonPollPost',
    components: { InteractionOfScale, InteractionOfBtnBackgroundColor, BookmarkPopup, ProfileImage },
    props: {
        pollPost: {
            type: Object,
            default: () => { }
        },
        index: {
            type: Number,
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        setLikeState: {
            type: Function,
            default: () => { }
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            POLL_TYPE: POLL_TYPE,
            copyPollPost: {},
            isShowBookmarkPopup: false,
            bookmarkFlag: false,
            IS_LIKE: IS_LIKE,
            poll_view_interval: null
        }
    },
    watch: {
        pollPost: {
            handler(newVal) {
                this.copyPollPost = window.copyObject(newVal)
                this.$nextTick(() => {
                    if (this.copyPollPost.is_me_poll) {
                        if (this.copyPollPost.poll_type === POLL_TYPE.IMAGE) {
                            this.setImageScale()
                        }
                        this.setRatio()
                    }
                })
            },
            immediate: true,
            deep: true
        }
    },
    deactivated() {
        if (this.poll_view_interval) clearInterval(this.poll_view_interval);
    },
    created() {
        this.copyPollPost = window.copyObject(this.pollPost)
        this.hidePoll = this.$Once(this.hidePoll)
        this.submitPoll = this.$Once(this.submitPoll)
        this.deletePoll = this.$Once(this.deletePoll)
        this.$nextTick(() => {
            if (this.copyPollPost.is_me_poll) {
                if (this.copyPollPost.poll_type === POLL_TYPE.IMAGE) {
                    this.setImageScale()
                }
                this.setRatio()
            }
        })

        if (this.$GlobalStore.isLogin()) {
            this.poll_view_interval = setInterval(async () => {
                if(!this.$refs.poll_post_wrap) return;

                const cur_rect = this.$refs.poll_post_wrap.getBoundingClientRect();

                const component_gap = 80;
                if (cur_rect.top + component_gap < window.innerHeight && cur_rect.top + component_gap > 0) {
                    const parameters = {};
                    parameters.poll_idx = this.copyPollPost.idx;
                    const res = await this.$Axios.post('/api/poll/set_view', parameters);
                    if (res.data.code === ResponseCode.SUCCESS) {
                        if (this.poll_view_interval) clearInterval(this.poll_view_interval);
                    }
                }
            }, 2000);
        }
    },
    computed: {
        curLikeYn() {
            return this.copyPollPost.is_me_liked ? 1 : 0
        },
        curLikeNumber() {
            if (this.copyPollPost.like_number === null || !this.copyPollPost.like_number) {
                return 0
            } else {
                return parseInt(this.copyPollPost.like_number)
            }
        },
    },
    methods: {
        showDetail() {
            if (this.isDetail) {
                return
            }
            this.$Util.sendEventClick('투표_자세히보기', true)
            this.$GlobalStore.addModal('PollPostDetail', { poll_idx: this.copyPollPost.idx })
        },
        touchStart() {
            if (!this.$GlobalStore.isLogin()) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
            }
        },
        touchEnd() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transition = 'all 0.3s'
                this.$refs.soccerBall.style.transform = 'rotate(0)'
                this.$refs.shoot.style.opacity = '1'
                this.$refs.shoot.style.transition = 'all 0.3s'
            } else {
                this.$refs.shoot.style.transition = ''
                this.$refs.shoot.style.opacity = '0'
            }
            let likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            let likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            this.$set(this.copyPollPost, 'is_me_liked', likeTemp == 1 ? true : false);
            this.$set(this.copyPollPost, 'like_number', likeNumber);
            this.setLikeState(likeTemp, likeNumber)
            this.toggleLike();
            this.$Util.vibrate();
        },
        async toggleLike() {
            const parameters = {};
            parameters.likeYn = this.curLikeYn === IS_LIKE.UNLIKE ? '0' : '1';
            parameters.idx = this.copyPollPost.idx

            const res = await this.$Axios.post('/api/poll/like', parameters);
            if (res.data.code === -1) {
                alert(res.data.msg);
            }
        },
        closeBookmarkPopup(isHide = false) {
            this.isShowBookmarkPopup = false
            setTimeout(() => {
                this.bookmarkFlag = false
                if (isHide) {
                    this.completeAction(this.index)
                }
            }, 510)
        },
        confirmHidePoll() {
            this.bookmarkFlag = true
            setTimeout(() => {
                this.isShowBookmarkPopup = true
            }, 10)
        },
        async hidePoll() {
            const formData = new FormData()
            formData.append('poll_idx', this.copyPollPost.idx)

            const res = await this.$Axios.post('/api/poll/hide', formData)

            if (res.data.code === 0) {
                this.closeBookmarkPopup(true)
                this.$Util.sendEventClick('투표_숨기기', true)
            }
        },
        setRatio() {
            this.$nextTick(() => {
                const maxRatio = Math.max(...this.copyPollPost.options.map(item => item.ratio));

                this.copyPollPost.options.forEach((item, index) => {
                    const el = this.$refs.progress_bar[index];
                    el.style.width = `${item.ratio}%`;
                    el.style.backgroundColor = parseInt(item.ratio) === maxRatio ? 'var(--color-main)' : '#BBBBBB';
                });
            });
        },
        setImageScale() {
            this.$nextTick(() => {
                const options = this.copyPollPost.options;
                const ratios = options.map(item => parseInt(item.ratio));
                const maxRatio = Math.max(...ratios);

                const maxRatioIndexes = options
                    .map((item, index) => ({ index, ratio: parseInt(item.ratio) }))
                    .filter(item => item.ratio === maxRatio)
                    .map(item => item.index);

                const totalItems = options.length;
                const totalMax = maxRatioIndexes.length;

                options.forEach((item, index) => {
                    const el = this.$refs.test[index];

                    if (totalItems === 2 && totalMax === 2) {
                        // 항목 2개이고 둘 다 동률이면 원래 크기
                        el.style.scale = '1';
                    } else if (totalItems >= 3 && totalMax === totalItems) {
                        // 전부 동률
                        el.style.scale = '1';
                    } else if (totalItems >= 3 && totalMax === 2) {
                        // 3개 이상이고 동률 항목 2개
                        el.style.scale = maxRatioIndexes.includes(index) ? '1' : '0.95';
                    } else {
                        // 일반적인 경우 (최대만 강조)
                        el.style.scale = parseInt(item.ratio) === maxRatio ? '1.05' : '0.95';
                    }
                });
            });
        },
        async submitPoll(type, option) {
            if (this.copyPollPost.is_me_poll) {
                return
            }

            const formData = new FormData()
            formData.append('poll_idx', option.poll_idx)
            formData.append('poll_option_idx', option.idx)

            const res = await this.$Axios.post('/api/poll/save', formData)

            if (res.data.code === 0) {
                this.$Util.sendEventClick('투표_확정', true)
                const options = res.data.options
                this.$set(this.copyPollPost, 'options', options)
                this.$set(this.copyPollPost, 'is_me_poll', { poll_option_idx: option.idx })
                this.$set(this.copyPollPost, 'poll_cnt', res.data.poll_cnt)
                this.setRatio()
                if (type === POLL_TYPE.IMAGE) {
                    this.setImageScale()
                }
            }
        },
        async deletePoll(type) {
            const formData = new FormData()
            formData.append('poll_idx', this.copyPollPost.idx)

            const res = await this.$Axios.post('/api/poll/delete', formData)

            if (res.data.code === 0) {
                this.copyPollPost = window.copyObject(this.pollPost)
                this.$set(this.copyPollPost, 'is_me_poll', null)
                this.$set(this.copyPollPost, 'poll_cnt', res.data.poll_cnt)
                this.copyPollPost.options.forEach((item, index) => {
                    this.$refs.progress_bar[index].style.width = '0%'
                    this.$refs.progress_bar[index].style.backgroundColor = ''
                    if (type === POLL_TYPE.IMAGE) {
                        this.$refs.test[index].style.scale = '1'
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.poll_btn {
    width: 270px;
    border: 1px solid #ebebeb;
    border-radius: 50px;
    padding: 12px 20px;
    font-size: 12px;
    font-weight: 500;
    position: relative;
    min-height: 41px;
    overflow: hidden;
}

.not_complete {
    transform: translateX(-50%);
    left: 50%;
}

.complete {
    transform: translateX(0%);
    left: 20px;
}

.progress_bar {
    position: absolute;
    transition: all 0.3s;
    width: 0%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>